// extracted by mini-css-extract-plugin
module.exports = {"card":"box_card__SIpNI","body":"box_body__8mG7Z"};